import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import PortableText from "react-portable-text"
// import Image from "gatsby-plugin-sanity-image"

const InterestingArticle = () => {
  const data = useStaticQuery(graphql`
    {
      sanityInterestingPage {
        title
        interestingSingleNote {
          _rawExcerptPortableText(resolveReferences: { maxDepth: 10 })
          _rawMainImage(resolveReferences: { maxDepth: 10 })
        }
      }
    }
  `)
  return (
    <div className="mt-5 bg-red-100 bg-opacity-30">
      <div className="relative" style={{ height: "60px" }}>
        <CategoryBar className="bg-fb-blue rounded-none md:rounded flex items-center pl-5 font-opensanscond category-bar inherit md:absolute">
          {data.sanityInterestingPage.title}
        </CategoryBar>
      </div>
      <div className="p-5">
        {/* <Image
          // pass asset, hotspot, and crop fields
          {...data.sanityInterestingPage.interestingSingleNote._rawMainImage}
          // tell Sanity how large to make the image (does not set any CSS)
          width={300}
          height={200}
          alt={
            data.sanityInterestingPage.interestingSingleNote._rawMainImage
              .alt || "Finanzas de Bolsillo"
          }
          className="rounded-t shadow"
          // style it how you want it
          style={{
            width: "100%",
            height: "20%",
            objectFit: "cover",
          }}
        /> */}
        {/* {data.sanityInterestingPage.interestingSingleNote._rawMainImage
          .caption !== null && (
          <figcaption className="text-gray-600 font-roboto font-thin text-xs pl-3">
            {
              data.sanityInterestingPage.interestingSingleNote._rawMainImage
                .caption
            }
          </figcaption>
        )} */}
        <div>
          <PortableText
            className="font-roboto"
            content={
              data.sanityInterestingPage.interestingSingleNote
                ._rawExcerptPortableText
            }
            // serializers={serializer}
          />
        </div>
      </div>
    </div>
  )
}

// const Header = styled.div`
//   height: 45px;
// `
const CategoryBar = styled.div`
  bottom: 0px;
  right: 5px;
  width: 100%;
  height: 60px;
`
export default InterestingArticle
